import InfoPageLayout, { InfoSection } from "@/components/InfoPageLayout";

export default function Privacy() {
  return (
    <InfoPageLayout
      eyebrow="Privacy Policy"
      title="Your family's information belongs to you."
      intro="GuardianNest exists to give caregivers calm, organized access to health information. That mission only works if you trust us with what you store — so here is exactly how we handle it."
      updated="July 2026"
    >
      <InfoSection title="What we collect">
        <p>
          We collect only what's needed to run the caregiving features you use: your account details
          (name, email, and — if you enable it — a verified phone number), the health information you
          choose to add to profiles you create (allergies, medications, appointments, records,
          insurance, contacts), and standard technical data your device sends when using the app
          (IP, browser type, crash logs).
        </p>
        <p>
          We do <strong className="text-foreground">not</strong> buy health data from data brokers or
          pull records from third-party health systems unless you explicitly connect them.
        </p>
      </InfoSection>

      <InfoSection title="How we use it">
        <p>
          Your data is used to power the features in the app — displaying records, sending reminders
          you set, generating doctor reports and emergency views you request, and letting you share
          access with caregivers you choose. We also use aggregated, non-identifying signals to keep
          the app secure and to fix bugs.
        </p>
        <p>
          We never sell your data. We never rent your data. We never use your family's health
          information to train advertising models.
        </p>
      </InfoSection>

      <InfoSection title="Who can see it">
        <p>
          Only you and the caregivers you explicitly invite through the Shared Access feature can
          view the profiles you own. You control the role, scope, and duration of every invitation
          and can revoke it in one tap.
        </p>
        <p>
          Our team can only access account content when strictly necessary — for example, when you
          file a support request and grant us permission, or when required by law. All such access
          is logged.
        </p>
      </InfoSection>

      <InfoSection title="Your rights">
        <p>
          You can export your data, delete individual records, or permanently close your account
          from the app at any time. Deletion removes your records from our production systems within
          30 days and from encrypted backups on the standard backup rotation.
        </p>
      </InfoSection>

      <InfoSection title="Children's information">
        <p>
          Many GuardianNest profiles describe children. Parents and legal guardians control those
          profiles. The app is not designed for use by children directly, and we do not knowingly
          create accounts for anyone under 13.
        </p>
      </InfoSection>

      <InfoSection title="Contact">
        <p>
          Privacy questions, data requests, or concerns should go to{" "}
          <a
            href="mailto:privacy@guardiannest.net"
            className="font-semibold text-primary hover:underline"
          >
            privacy@guardiannest.net
          </a>
          . We respond within five business days.
        </p>
      </InfoSection>
    </InfoPageLayout>
  );
}
